/* jshint esversion: 6 */

export default class AbstractDirective {

	constructor() {
		this.restrict = 'A';
	}

	link(scope, element, attributes, controller) {
		const node = element[0];
		const abstractText = node.innerHTML;

		if (node.getAttribute('href') != undefined) {
			const link = document.createElement('a');
			link.setAttribute('href', node.getAttribute('href'));
			link.setAttribute('target', '_blank');
			link.innerHTML = abstractText;
			node.replaceWith(link);
			link.setAttribute('data-abstract', link.outerHTML);
		}
		else {
			node.setAttribute('data-abstract', abstractText);
		}
	}

	static factory() {
		return new AbstractDirective();
	}

}

AbstractDirective.factory.$inject = [];
